module.exports = __webpack_public_path__ + "static/media/brochureSilestone.6bd3dbb4.jpg";